import { useBaseAPI } from 'apiServices/baseAPI';

export function useScim2API({ patientID }) {
  return useBaseAPI(
    {
      method: 'POST',
      route: 'ehrrunner/scim2/Users/.search',
      additionalHeaders: {
        Accept: '*/*',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        schemas: [
          'urn:ietf:params:scim:api:messages:2.0:SearchRequest',
        ],
        filter: `userName Eq ${patientID}`,
        domain: 'PRIMARY',
        startIndex: 1,
        count: 10,
      }),
      timeout: 2000,
    },
  );
}
